import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
/**
 * Constant imports.
 */
import { ACTION_TYPE, COMMUNITY_POSTED_CONTENT_TYPE_ACTION, CTA_TYPE, NUMBERS, PRODUCT_TYPE_CONSTANT_NAME } from '../../constants/app.constants';
/**
  * Service imports
  */
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { Analytics } from 'analytics2.0';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-community-posts-filter',
  templateUrl: './community-posts-filter.component.html',
  styleUrls: ['./community-posts-filter.component.scss']
})
export class CommunityPostsFilterComponent implements OnInit {
  /**
   * Get Posted By Filter Data from Community Detail Component
   */
  @Output() changePostFilter = new EventEmitter();
  @Output() resetOffSet = new EventEmitter();
  /**
   * Emits reload feed events
   */
  @Output() emitReloadFeed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() postedByFilterData;
  @Input() postDataByFilter;
  @Input() postOffSet;
  @Input() postDataLoader:boolean;
  @Input() topicList;

  /**
   * whether community Admin
   */
  @Input() isCommunityAdmin = false;
  public posted_by = '';
  public content_type = '';
  public fobj = { posted_by: '', content_type: '' };

  public topicId = '';
  /**
   * Translations Data
   */
  public translations = {
    key1: this.mls.languageText.community.key38,
    key2: this.mls.languageText.community.key39
  };
  /**
   * Show commnity filter
   */
  public showfilter = false;
  /**
   * Device is mobile or not
   */
  public isMobile: boolean;

  public topicActiveState = false;
  /**
   * Initaile service
   */
  constructor(public mls: NewLanguageService, public fcs: FunCollectionService,  private analyticSdk: Analytics,  private route: ActivatedRoute) { }

  /**
   * On Initialize
   */
  ngOnInit(): void {
    this.isMobile = this.fcs.device_detail.is_mobile;
    // tslint:disable-next-line: no-unused-expression
    this.postedByFilterData && this.postedByFilterData.filter.forEach((fitem) => {
      fitem['activeState'] = false;
    });
  }

  /**
   * Get Posted By Filter
   */
  getPostsByFilter(fitem?, obj?): void {
    if (fitem === COMMUNITY_POSTED_CONTENT_TYPE_ACTION.COMMUNITY_POSTED_BY) {
      this.posted_by = obj.value || '';
      this.fobj[COMMUNITY_POSTED_CONTENT_TYPE_ACTION.POSTED_BY] = this.posted_by;
    }
    if (fitem === COMMUNITY_POSTED_CONTENT_TYPE_ACTION.COMMUNITY_CONTENT_TYPE) {
      this.content_type = obj.value || '';
      this.fobj[COMMUNITY_POSTED_CONTENT_TYPE_ACTION.CONTENT_TYPE] = this.content_type;
    }
    if (fitem === COMMUNITY_POSTED_CONTENT_TYPE_ACTION.TOPIC) {
      this.topicId = obj || '';
      this.fobj[COMMUNITY_POSTED_CONTENT_TYPE_ACTION.TOPIC] = this.topicId;
    }
    this.fobj['scroll'] = false;
    this.changePostFilter.emit(this.fobj);

    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,this.route.snapshot.params['communityId'],this.fcs.currentScreename, CTA_TYPE.TAB, ACTION_TYPE.CLICK, fitem+"_FILTER", null );
  }

  /**
   * Set Post Data Off Set
   */
  setPostDataOffset(offset): void {
    this.fobj['offset'] = offset  || NUMBERS.ONE;
    this.fobj['scroll'] = offset > NUMBERS.ONE ? true : false;
    this.changePostFilter.emit(this.fobj);
  }
  /**
   * Show filte or hide
   */
  showFilter(index): void {
    this.showfilter = !this.showfilter;
    this.postedByFilterData.filter[index]['activeState'] = this.showfilter;
  }
  /**
   * Show filte or hide
   */
  showTopic(): void {
    this.showfilter = !this.showfilter;
    this.topicActiveState = this.showfilter;
  }
  /**
   * Event handler to emit reload feed event
   * @param event for reload feed
   */
  reloadFeed(event: boolean): void {
    this.emitReloadFeed.emit(event);
  }
}
